import { useContext } from "react";
import { Spinner } from "../../../components";
import AuthContext from "../../../context/AuthContext";
import { COIAdmin } from "./COIAdmin";
import { COIClient } from "./COIClient";

export const COIPage = () => {
  const { idRole, isLoading } = useContext(AuthContext);
  if (isLoading) return <Spinner />;
  return idRole === 3 ? <COIClient /> : <COIAdmin />;
};
